import confetti from "canvas-confetti";

// تأثير قصاصات الورق الملوّنة عند نجاح تسجيل الحضور — يُطلق بالتزامن مع تحية «صباح الخير».
const COLORS = ["#BD9B57", "#0F2A1D", "#FFD700", "#FF6B6B", "#4ECDC4",
  "#45B7D1", "#96CEB4", "#FFEAA7", "#DDA0DD", "#98D8C8"];

const randomInRange = (min, max) => Math.random() * (max - min) + min;

export const fireConfetti = () => {
  const duration = 5000;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };
  const shapes = ["square", "circle"];

  const interval = setInterval(() => {
    const timeLeft = animationEnd - Date.now();
    if (timeLeft <= 0) return clearInterval(interval);
    const particleCount = 50 * (timeLeft / duration);
    const wing = { colors: COLORS, shapes, scalar: randomInRange(0.8, 1.2), gravity: randomInRange(0.8, 1.2), drift: randomInRange(-0.5, 0.5) };
    confetti({ ...defaults, ...wing, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
    confetti({ ...defaults, ...wing, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
    confetti({ ...defaults, particleCount: particleCount / 2, colors: COLORS, shapes, scalar: randomInRange(1, 1.5), gravity: 1.2, origin: { x: 0.5, y: randomInRange(0.1, 0.3) } });
  }, 250);

  confetti({ particleCount: 150, spread: 100, origin: { y: 0.6 }, colors: COLORS, shapes, scalar: 1.2, zIndex: 9999 });
  confetti({ particleCount: 100, angle: 60, spread: 55, origin: { x: 0 }, colors: COLORS, zIndex: 9999 });
  confetti({ particleCount: 100, angle: 120, spread: 55, origin: { x: 1 }, colors: COLORS, zIndex: 9999 });
};
